import { apiClient } from "./apiClient";

const unwrapData = (result, fallback = null) => {
  if (result?.data?.data !== undefined) {
    return result.data.data;
  }

  if (result?.data !== undefined) {
    return result.data;
  }

  if (result !== undefined && result !== null) {
    return result;
  }

  return fallback;
};

/* 관리자 목록 조회 */
export const getAdminList = async ({ page = 0, size = 100 } = {}) => {
  const result = await apiClient(`/api/admin/users?page=${page}&size=${size}`);

  return unwrapData(result, []);
};

/* 관리자 추가 */
export const createAdmin = async ({ loginId, userName, password, roleGroup }) => {
  const result = await apiClient("/api/admin/users", {
    method: "POST",
    body: JSON.stringify({
      loginId,
      userName,
      password,
      roleGroup,
    }),
  });

  return unwrapData(result, null);
};

/* 관리자 수정 */
export const updateAdmin = async (
  targetUserId,
  { loginId, userName, password, roleGroup }
) => {
  const body = {
    loginId,
    userName,
    roleGroup,
  };

  if (password) {
    body.password = password;
  }

  const result = await apiClient(`/api/admin/users/${targetUserId}`, {
    method: "PUT",
    body: JSON.stringify(body),
  });

  return unwrapData(result, null);
};

/* 관리자 삭제 */
export const deleteAdmin = async (targetUserId) => {
  const result = await apiClient(`/api/admin/users/${targetUserId}`, {
    method: "DELETE",
  });

  return unwrapData(result, null);
};

/* 관리자 비밀번호 초기화 */
export const resetAdminPassword = async (targetUserId) => {
  const result = await apiClient(
    `/api/admin/users/${targetUserId}/password/reset`,
    {
      method: "PATCH",
    }
  );

  return unwrapData(result, null);
};

/* 중운위 목록 조회 */
export const getCollegeList = async () => {
  const result = await apiClient("/api/admin/colleges", {
    method: "GET",
  });

  return unwrapData(result, []);
};

/* 중운위 이름 수정 */
export const updateCollegeName = async (collegeId, collegeName) => {
  const result = await apiClient(`/api/admin/colleges/${collegeId}`, {
    method: "PUT",
    body: JSON.stringify({
      collegeName,
    }),
  });

  return unwrapData(result, null);
};